/**
 * Function to customize the #atlwdg-trigger element
 */
const jiraBugButton = () => {

    /**
     * Wait until the #atlwdg-trigger element is added to the DOM
     */
    const customizeAtlwdgTrigger = () => {
        const trigger = document.querySelector('#atlwdg-trigger');

        if (trigger) {
            // Change text
            trigger.textContent = 'Report a Bug';

            // Add font style
            trigger.style.fontFamily = '"Avenir", sans-serif'; // Replace with your desired font

            // Add the Material Icon for bug_report
            trigger.innerHTML = `<span class="material-icons" style="margin-right: 8px; color: #414042; font-size: 18px;">bug_report</span>${ trigger.innerHTML }`;

            // Add additional styles to trigger
            trigger.style.display = 'flex';
            trigger.style.alignItems = 'center';
            trigger.style.justifyContent = 'center';
            trigger.style.paddingRight = '8px';
            trigger.style.paddingLeft = '6px';
            trigger.style.paddingTop = '4px';
            trigger.style.paddingBottom = '4px';
            trigger.style.height = '30px';

            // Add border to the trigger with .atlwdg-SUBTLE class
            const subtleTrigger = document.querySelector('.atlwdg-trigger.atlwdg-SUBTLE');
            if (subtleTrigger) {
                subtleTrigger.style.border = '1px solid black';
                subtleTrigger.style.borderRadius = '2px';
            }
        }
    };

    // Set a MutationObserver to watch for the element
    const observer = new MutationObserver((mutations, obs) => {
        if (document.querySelector('#atlwdg-trigger')) {
            customizeAtlwdgTrigger();
            obs.disconnect(); // Stop observing once the element is found and customized
        }
    });

    // Start observing the DOM
    observer.observe(document, {
        childList: true,
        subtree: true
    });
};

export default jiraBugButton;